<template>
  <base-form :title="$t('user.details.password.title')"
             class="row user-details-password"
             :loading="loading"
             @submit="submit">
    <div>
      <fg-input :placeholder="$t('user.details.password.currentPassword')"
                :name="$t('user.details.password.currentPassword')"
                :label="$t('user.details.password.currentPassword')"
                :error="getError($t('user.details.password.currentPassword'))"
                type="password"
                v-validate="modelValidations.currentPassword"
                v-model="model.currentPassword">
      </fg-input>
      <div class="flex">
        <div class="w-full md:w-1/2 md:mr-3">
          <fg-input :placeholder="$t('user.details.password.newPassword')"
                    :name="$t('user.details.password.newPassword')"
                    :label="$t('user.details.password.newPassword')"
                    :error="getError($t('user.details.password.newPassword'))"
                    type="password"
                    ref="newPassword"
                    v-validate="modelValidations.newPassword"
                    v-model="model.newPassword">
          </fg-input>
        </div>
        <div class="w-full md:w-1/2">
          <fg-input :placeholder="$t('user.details.password.newPasswordConfirm')"
                    :name="$t('user.details.password.newPasswordConfirm')"
                    :label="$t('user.details.password.newPasswordConfirm')"
                    :error="getError($t('user.details.password.newPasswordConfirm'))"
                    type="password"
                    v-validate="modelValidations.newPasswordConfirm"
                    v-model="model.newPasswordConfirm">
          </fg-input>
        </div>
      </div>
    </div>
  </base-form>
</template>
<script>
  import BaseAvatar from 'src/components/BaseAvatar'
  import UserService from 'src/services/UserService'

  export default {
    name: 'user-details-password',
    components: {
      BaseAvatar
    },
    props: {
      user: {
        type: Object,
        default: () => ({})
      }
    },
    data () {
      return {
        loading: false,
        model: {
          currentPassword: '',
          newPassword: '',
          newPasswordConfirm: ''
        }
      }
    },
    computed: {
      modelValidations () {
        return {
          currentPassword: {
            required: true,
            min: 6
          },
          newPassword: {
            required: true,
            min: 8,
            is_not: this.model.currentPassword
          },
          newPasswordConfirm: {
            required: true,
            min: 8,
            confirmed: 'newPassword',
            is_not: this.model.currentPassword
          }
        }
      }
    },
    methods: {
      async submit () {
        let res = await this.$validator.validateAll()
        if (res) {
          try {
            this.loading = true
            await UserService.changePassword(this.model)
            this.$notify({
              type: 'success',
              message: this.$t('passwordChange.success'),
            })
          } finally {
            this.loading = false
          }
        }
      }
    }
  }
</script>
<style lang="scss">
  .user-details-password {
    .picture-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
</style>
